import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { contactKeys } from './queryKeys';
import useQueryRequestParams from '../../../hooks/useQueryRequestParams';
import markUrl from './markUrl';
const useDemoProfiles = (params) => {
    const additional = useQueryRequestParams();
    return useQuery({
        queryFn: () => axios.get(markUrl('profiles/demo/'), {
            ...additional,
            params
        }),
        queryKey: contactKeys.demoList(params)
    });
};
export default useDemoProfiles;
